// extracted by mini-css-extract-plugin
export var buttons = "_bb-0";
export var buttonsActive = "_bb-h";
export var cancelConfirm = "_bb-1";
export var closeButton = "_bb-2";
export var column = "_bb-3";
export var container = "_bb-4";
export var detailHeader = "_bb-6";
export var detailTitle = "_bb-7";
export var detailsContent = "_bb-5";
export var header = "_bb-8";
export var headerWithClose = "_bb-9";
export var icon = "_bb-a";
export var infoIcon = "_bb-c";
export var informationContainer = "_bb-b";
export var sideDrawer = "_bb-d";
export var sideDrawerOpen = "_bb-e";
export var stickyFooter = "_bb-f";
export var typeOption = "_bb-g";